export default "__VITE_ASSET__Tjz6gaiH__"